<template>
    <div :class="{
        criteria: true,
        criteria_readonly: readonly,
    }">
        <div class="criteria__header">
            {{ score.name }}
        </div>
        <div class="criteria__table">
            <table>
                <tr>
                    <th></th>
                    <th v-for="relation of score.relations" :key="`column${relation.id}`">{{ relation.name }}</th>
                </tr>
                <tr v-for="criteria of score.criterias" :key="`row${criteria.id}`">
                    <td>
                      <div class="criteria__name">{{ criteria.name}}</div>
                    </td>
                    <td v-for="relation of score.relations" :key="`cell${criteria.id}-${relation.id}`">
                        <div v-if="readonly" class="criteria__relation">
                            <img v-if="inputValue[criteria.id] === relation.id" src="@/assets/images/expert-panel/checked.svg" />
                            <img v-else src="@/assets/images/expert-panel/unchecked.svg" />
                        </div>
                        <div v-else class="criteria__relation">
                            <img v-if="inputValue[criteria.id] === relation.id" src="@/assets/images/expert-panel/checked.svg" />
                            <img v-else src="@/assets/images/expert-panel/unchecked.svg" @click="inputValue[criteria.id] = relation.id" />
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "ExpertPanelReviewAssessmentCriteria",
    props: {
        score: Object,
        value: Object,
        readonly: Boolean,
    },
    data() {
        return {
            inputValue: this.score.criterias.reduce((res, criteria) => {
                res[criteria.id] = this.value && this.value[criteria.id] ? this.value[criteria.id] : '';
                return res;
            }, {}),
        };
    },
    computed: {
        completed() {
            return Object.values(this.inputValue).filter((val) => val === '').length === 0;
        },
    },
    watch: {
        inputValue: {
            handler() {
                this.$emit('completed', this.completed);
                this.$emit('input', this.inputValue);
            },
            deep: true,
        },
    },
    mounted() {
        this.$emit('completed', this.completed);
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.criteria {
  font-family: Montserrat, sans-serif;
  &__header {
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(24);
    color: #2A2626;
    margin-bottom: rem(16);
  }
  &__table {
    overflow-x: auto;
    width: 100%;
    padding-bottom: rem(6);
    &::-webkit-scrollbar {
      height: rem(6);
    }
    &::-webkit-scrollbar-thumb {
      background: #D6E0EA;
      border-radius: rem(20);
    }
    &::-webkit-scrollbar-track {
      background: none;
    }
  }
  table {
    border-spacing: 0;
    border-collapse: separate;
    th {
      font-weight: 600;
      font-size: rem(14);
      line-height: rem(20);
      color: #2A2626;
      padding: 0 rem(16) 0 0;
      text-align: center;
      &:first-child {
        text-align: left;
      }
    }
    td {
      font-weight: 400;
      font-size: rem(14);
      line-height: rem(20);
      color: #010101;
      padding: rem(16) rem(16) rem(16) 0;
      border-bottom: solid 1px #D9D9D9;
      text-align: center;
      &:first-child {
        text-align: left;
      }
    }
  }
  &__name {
    width: rem(200);
  }
  &__relation {
    width: rem(150);
  }
  &_readonly {
    table {
      td {
        img {
          opacity: 0.4;
        }
      }
    }
  }
}
</style>